const toggleAriaExpanded = (element) => {
  const ariaExpandedValue = element.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
  element.setAttribute('aria-expanded', ariaExpandedValue);
};

export default toggleAriaExpanded;
